import React from 'react';
import ReactDOM from 'react-dom/client';
import './style/tailwind.css';
import './style/index.scss';
import App from './App';
import { AuthContextProvider } from './components/Auth/AuthContext';
import { injectGlobalOverrides } from './utils/customDialog';

injectGlobalOverrides();

const initialTheme = localStorage.getItem("emailApp_theme") || "light";
if (initialTheme === "light") {
  document.body.classList.add("light-theme");
} else {
  document.body.classList.remove("light-theme");
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthContextProvider>
      <App />
    </AuthContextProvider>
  </React.StrictMode>
);
